import AIChatbotSection from "../adminLandingPage/LandingPage/AIChatbotSection";
import Cta from "../adminLandingPage/LandingPage/Cta";
import Features from "../adminLandingPage/LandingPage/Features";
import Hero from "../adminLandingPage/LandingPage/Hero";
import Pricing from "../adminLandingPage/LandingPage/Pricing";
import UpToTheTop from "../adminLandingPage/LandingPage/UpToTheTop";
import Wrappers from "../adminLandingPage/Wrappers/Wrappers";
import AnalyticsDashboardSection from "../adminLandingPage/LandingPage/AnalyticsDashboardSection";
import MultiBranchSection from "../adminLandingPage/LandingPage/MultiBranchSection";
import FeatureHighlightsCarousel from "../adminLandingPage/LandingPage/FeatureHighlightsCarousel";

const UserLandingPage = () => {
  return (
    <main
      dir="ltr"
      className="min-h-screen overflow-hidden bg-gradient-to-br from-orange-50 to-amber-50 text-gray-800"
    >
      <Wrappers>
        <Hero />
        <Features />
        <AnalyticsDashboardSection />
        <AIChatbotSection />
        <MultiBranchSection />
        <FeatureHighlightsCarousel />
        {/* <Pricing /> */}
        <Cta />
        <UpToTheTop />
      </Wrappers>
    </main>
  );
};

export default UserLandingPage;
